/**
 * ReferenceSection — the project-level "Reference" root node.
 *
 * The project top level shows exactly two roots: Schedule (where work happens,
 * under phases) and Reference (this node). Reference gates the collection
 * sections — Team, Meetings, Threads, Design, Production, Permits,
 * Construction — which remain independent portaled section components: each
 * renders its own root row indented (.wf-ref-child) when this node is
 * expanded, and children-only when Reference is zoomed (wf.zoomRoot ===
 * 'reference'; ZoomTitle supplies the "Reference" title).
 *
 * This component renders ONLY the Reference row itself.
 */

import { useEffect, useReducer } from 'react'
import { wf } from '../outline/state.js'

function calcReferenceVis() {
  if (!wf.zoomProjectId) return 'hidden'
  if (!wf.zoomRoot && !wf.zoomPhaseId && !wf.zoomMsId && !wf.zoomSection &&
      !wf.zoomCat && !wf.zoomItemId && !wf.zoomConceptId && !wf.searchQuery) return 'home'
  return 'hidden'
}

export default function ReferenceSection() {
  const [, forceUpdate] = useReducer(v => v + 1, 0)

  useEffect(() => {
    function onRender() { forceUpdate() }
    window.addEventListener('outline-render', onRender)
    return () => window.removeEventListener('outline-render', onRender)
  }, [])

  const vis = calcReferenceVis()
  if (vis === 'hidden') return null

  const rootCollapsed = wf.collapsed['root:reference'] !== false

  /* Children (the seven reference sections) are sibling portaled components
     that gate themselves on this collapse key — this node has no wf-children
     div of its own. */
  return (
    <div className="wf-list">
      <div
        className={`wf-node wf-node--root wf-node--root-reference${rootCollapsed ? ' wf-node--collapsed' : ''}`}
        data-key="root:reference"
      >
        <div className="wf-row">
          <button className="wf-triangle" data-fn="toggleCollapse" data-key="root:reference">
            <span className={`wf-tri-icon ${rootCollapsed ? 'wf-tri-icon--right' : 'wf-tri-icon--down'}`}></span>
          </button>
          <button
            className="wf-bullet wf-bullet--root"
            title="Focus on Reference"
            data-fn="zoomTo"
            data-level="root"
            data-rootname="reference"
          ></button>
          <div className="wf-text-wrap">
            <span className="wf-node-text wf-node-text--root">Reference</span>
          </div>
          <button
            className="wf-menu-btn"
            data-fn="openMenu"
            data-type="root"
            data-key="root:reference"
            data-rootname="reference"
          >&#8943;</button>
        </div>
      </div>
    </div>
  )
}
